export default __webpack_public_path__ + "my-first-project-visual.png";